import { getSortedPostsByTag } from '$lib/posts';
import type { Load } from '@sveltejs/kit';

export const load: Load = ({ params: { tag } }) => {
	return {
		tag,
		posts: getSortedPostsByTag(tag!)
	};
};
